import { render, staticRenderFns } from "./OnlineKasko.vue?vue&type=template&id=bdf244f4"
import script from "./OnlineKasko.vue?vue&type=script&lang=ts"
export * from "./OnlineKasko.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports